import { render } from "./CommessaDetail.vue?vue&type=template&id=64a10512&scoped=true"
import script from "./CommessaDetail.vue?vue&type=script&lang=js"
export * from "./CommessaDetail.vue?vue&type=script&lang=js"

import "./CommessaDetail.vue?vue&type=style&index=0&id=64a10512&scoped=true&lang=css"

import exportComponent from "/Users/michael/Sites/firegui_multilink_app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a10512"]])

export default __exports__